import { validatePresence } from 'ember-changeset-validations/validators'

export default {
  newGrade: [validatePresence(true)],
}
